import $ from 'jquery';

import 'Lib/jquery.onmutate';

import whenDomReady from 'when-dom-ready';
import ViewGlobal from 'Views/view-global';

$(document).onCreate('body', () => {

    "use strict";
    
    console.log('Body created, routing...');
    
    var $body = $(document.body);

    if (!$.support.transition) {
        $.fn.transition = $.fn.beforeanimate;
    };
    
    // Global requires
    whenDomReady(function(){
        ORW.Global = new ViewGlobal({el: $body});
    });

    // Start routing by template type
    console.log('Routing...' + ' ' + $body.attr('class'));

    if ($body.hasClass('template-index')) {
        require('Pages/page-home');
    }

    if ($body.hasClass('template-product')) {
        require('Pages/page-product');
    }

});